import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { ArrowLeft } from 'lucide-react';

const Terms = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 py-20">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <Button 
          variant="outline" 
          onClick={() => navigate('/')}
          className="mb-8"
        >
          <ArrowLeft className="w-4 h-4 mr-2" />
          Back to Home
        </Button>

        <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-lg p-8 md:p-12">
          <h1 className="text-4xl font-bold text-gray-900 mb-8">Terms & Conditions</h1>
          
          <div className="prose prose-gray max-w-none space-y-6 text-gray-700 leading-relaxed">
            <section>
              <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">1. INTRODUCTION</h2>
              <p>This contract is formed between you (referred to in these Terms & Conditions as "the Customer") and Wedding Video Essex LTD once the Booking Fee (minimum 50%) has been received. The "Product or Service" shall mean any product or service provided by Wedding Video Essex LTD to the Customer. These conditions do not affect your statutory rights.</p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">2. SUPPLY</h2>
              <p>Wedding Video Essex LTD agrees to supply the Product(s) or Service(s) to the Customer as detailed in the order and in accordance with the terms and conditions of this contract.</p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">3. RIGHTS RESERVED</h2>
              <p>Should Wedding Video Essex LTD choose not to enforce any or all of these conditions, it shall not be interpreted as a waiver of any of the Company's rights. By placing an Order with Wedding Video Essex LTD, the Customer accepts these terms and conditions.</p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">4. PAYMENT</h2>
              <p>Wedding Video Essex LTD shall issue an invoice to the Customer for the Product(s) or Service(s) supplied or to be supplied, with payment terms stipulated on the invoice. A 50% booking fee is required at the time of booking. Full payment is required no later than 30 days before the wedding date. Accepted payment methods include Bank Transfer, Credit Card, and Debit Card. We process all payments through a secure online portal.</p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">5. HEALTH & SAFETY</h2>
              <p>Both parties shall comply with all relevant Health & Safety regulations throughout the duration of services being provided.</p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">6. CREATIVE BRIEF</h2>
              <p>Unless otherwise agreed in writing, the Customer entrusts Wedding Video Essex LTD with creative control. This includes all elements detailed within the invoice. Some services may not be possible due to time constraints, weather, venue restrictions, or other limiting factors. We include TWO REVISIONS of the final product free of charge. Additional edits beyond this are charged at £50 per hour.</p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">7. BOOKING FEE/CANCELLATION</h2>
              <p>Monies paid by the Customer to reserve the Product(s) or Service(s) will be accepted as a non-refundable Booking Fee. If cancellation occurs less than 6 months before the event, the Customer will be liable for the full invoice total, minus the Booking Fee. If cancellation occurs with more than 6 months' notice, the Booking Fee will be held as a credit note for a future booking. Wedding Video Essex LTD will make reasonable efforts to accommodate date changes.</p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">8. LIABILITY</h2>
              <p>Wedding Video Essex LTD accepts no liability for loss or damage beyond the total value of the invoice or amount already paid by the Customer. We employ robust data protection protocols including dual local backups, offsite backup, and cloud backup via Amazon AWS. In the rare event of technical failure (e.g. corrupt memory cards, equipment malfunction, data loss), Wedding Video Essex LTD will make reasonable efforts to recover footage. However, the total liability is limited to the amount paid by the Customer for the affected product(s) or service(s).</p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">9. COPYRIGHT</h2>
              <p>Unless otherwise stated, Wedding Video Essex LTD retains full copyright of all original materials including videos, graphics, music, and artwork. Customers are responsible for obtaining permissions for any copyrighted material they supply. All music must be original and legitimately owned. We retain the right to use finished materials for promotional purposes unless explicitly agreed otherwise.</p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">10. DATA PROTECTION</h2>
              <p>It is the Customer's responsibility to ensure that all necessary permissions are obtained from individuals appearing in the footage. Wedding Video Essex LTD reserves the right to use excerpts from the final product for promotional purposes across websites, social media, and third-party platforms.</p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">Additional Terms</h2>
              <p>For complete terms and conditions including sections on Force Majeure, Behavior Policy, Working Arrangements, Photography Services, Live Streaming, and Delivery Format, please contact us directly or visit our main website.</p>
            </section>

            <div className="bg-gray-100 rounded-lg p-6 mt-12">
              <p className="text-sm text-gray-600">
                These Terms & Conditions form the basis of the agreement between the Customer and Wedding Video Essex LTD.
                Last Updated: 2026
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Terms;